/* pd-cad.js : visiteurs canadiens (devise de la session = CAD) : libellé « CAD » après les prix actuels de la fiche
   (bloc prix + prix de chaque offre). Validé le 08/10/2026 (« Ok on peut afficher en CAD »). Les autres devises ne changent pas.
   Le libellé est posé en CSS (::after) : il suit les mises à jour de prix faites par le thème (variante, offre). Retrait : enlever
   la ligne pd-cad.js de layout/theme.liquid (install_cad.py --revert). */
(function () {
  var cur = '';
  try { cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || ''; } catch (e) {}
  if (cur !== 'CAD') return;
  document.documentElement.classList.add('pd-cad');
  var st = document.createElement('style');
  st.textContent = '.pd-cad .vs2-price-now::after,.pd-cad .price__sale .price-item--sale::after,.pd-cad .price__regular .price-item--regular::after'
    + '{content:" CAD";font-size:.62em;font-weight:700;letter-spacing:.02em;margin-left:.25em;vertical-align:.12em}';
  document.head.appendChild(st);
})();
